import {Component} from '@angular/core';

@Component({
  selector: 'app-refresh',
  template: ''
})
export class RefreshComponent {

}
